export const config = {
    bucketName: 'pov-pix',
    region: 'eu-west-3',
    accessKeyId: process.env.REACT_APP_S3_ACCESS,
    secretAccessKey: process.env.REACT_APP_S3_SECRET,
}